const sampleGroups = ["POSITIVE", "NEGATIVE", "UNASSIGNED"];

const getGroupActions = (group) => {
  const result = sampleGroups.filter((sampleGroup) => sampleGroup !== group);
  return result;
};

export default getGroupActions;
